import gql from 'graphql-tag';
import { useQuery } from '@apollo/client';

const QUERY = gql`
  query getSoftwareRefund($id: String!) {
    softwareRefund(id: $id) {
      swdlId
      recordDate
      userId
      refundNumber
      status
      reasonForRefund
      message
      helpRequestId
      downloadReason
      downloadResult
    }
  }
`;

const useSoftwareRefund = (id: string) => {
  const { data, error, loading } = useQuery(QUERY, { variables: { id } });

  if (error) {
    console.error(error);
    return null;
  }

  if (loading) {
    return null;
  }

  return data.softwareRefund;
};

export default useSoftwareRefund;
